<!--
    描述：会员详情
    时间：2022-06-22
    Created by zwh
-->
<template>
  <div class="member-detail-page">
    <div class="main-content">
      <el-row>
        <el-col :span="12">
          文件名称：{{objectForm.fileName}}
        </el-col>
        <el-col :span="12">
          文件id：{{objectForm.fileId}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          业务码（code)：
        </el-col>
        <el-col :span="12">
          业务信息：
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          业务数据：
        </el-col>
        <el-col :span="12">
          文档下载地址：{{objectForm.downUrl}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          合同类型：
        </el-col>
        <el-col :span="12">
          签署流程ID：{{objectForm.flowId}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          本地文件地址：
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-button type="primary" v-if="roleBtns.includes('contractView')"
                     size="small"
                     class="btn btn-blue"
                     @click="showView()">查看合同</el-button>
        </el-col>
      </el-row>
    </div>

    <!-- 查看合同 -->
    <el-dialog :title="viewDialogObj.title"
               :visible.sync="viewDialogObj.visible"
               :width="viewDialogObj.width"
               :close-on-click-modal="false"
               @close="viewDialogClose"
               center>
      <!-- 弹窗组件 -->
      <div v-if="viewDialogObj.visible" style="height: 730px">
        <iframe :src="filePreViewUrl" style="height: 100%;width: 100%"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapState} from "vuex";
import * as API from'api/modules/es/es_file.js'
export default {
  name: "detail",
  data(){
    return {
      objectForm : {

      },

      viewDialogObj : {
        title: '',
        visible: false,
        width: '600px',
        mode: 'add',
        stepIndex : 1,
      },

      //附件预览地址
      filePreViewUrl : ''
    }
  },
  computed: {
    ...mapState('app', { isBack: (state) => state.isBack }),
    ...mapState('menu', {
      roleBtns: (state) => state.roleBtns,
    }),
    routeQuery() {
      return this.$route.query.type
    },
    historyId() {
      return this.$route.query.id
    },
    // 预览环境变量
    previewUrl() {
      return process.env.VUE_APP_PREVIEW_URL
    },
  },
  created() {
    this.getObjectById()
  },
  methods :{
    getObjectById(){
      API.getObjectById({id: this.historyId}).then(res=>{
        if(res.operationCode == 1) {
          this.objectForm = res.data
        }
      })
    },
    //按钮事件
    showView(){
      //this.filePreViewUrl = this.previewUrl + this.objectForm.downUrl
      this.filePreViewUrl = "https://pdf.52ngs.com/onlinePreview?url="+this.objectForm.downUrl
      //console.log(this.filePreViewUrl)
      this.viewDialogObj.title = this.objectForm.fileName
      this.viewDialogObj.width = '1000px'
      this.viewDialogObj.visible = true
    },
    viewDialogClose(){
      this.viewDialogObj.visible = false
    },
  }
}
</script>

<style lang="less" scoped>
.member-detail-page {
  padding : 20px 50px;

  .main-content {
    font-family: 'Arial Normal', 'Arial';
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    color: #333333;
    line-height: normal;

    .el-row {
      padding : 10px 0px;
    }
  }
}
</style>